import React, { useState, useRef } from "react";
import { FaRegTrashAlt, FaUpload } from "react-icons/fa";
import { Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import axios from "axios";

const UploadImage = ({ baseUrl, onUploadSuccess }) => {
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const fileInputRef = useRef(null); // Ref for the file input element

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        showToast(
          `File size (${(file.size / (1024 * 1024)).toFixed(2)} MB) exceeds the 5 MB limit.`,
          { type: "danger" }
        );
        e.target.value = null;
        return;
      }
      // Validate file type
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        showToast("Invalid file type. Please upload a JPEG or PNG image.", {
          type: "danger",
        });
        return;
      }

      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setUploaded(false); // Reset uploaded state
      console.log("Selected image file:", file);
    }
  };

  // Remove the selected image
  const removeImage = () => {
    setImageFile(null); // Clear the image file state
    setImagePreview(null); // Clear the preview
    setUploaded(false); // Reset uploaded state
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input field
    }
    console.log("Image removed and file input reset.");
  };

  // Upload the image
  const uploadImage = async () => {
    if (!imageFile) {
      showToast("Please select an image to upload.", { type: "warning" });
      return;
    }

    try {
      console.log("Uploading image...");
      const formData = new FormData();
      formData.append("files", imageFile); // Use "files" as the key

      const response = await axios.post(
        `${baseUrl}/all/upload/files/images`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.statusType === "SUCCESS") {
        const imageUrl = response.data.propertyImages[0].image_url;
        console.log("Uploaded Image URL:", imageUrl);
        showToast("Image uploaded successfully!", { type: "success" });
        setUploaded(true); // Mark as uploaded

        // Pass the uploaded image URL to the parent component
        if (onUploadSuccess) {
          onUploadSuccess(imageUrl);
        }
      } else {
        console.error("Image upload failed:", response.data);
        showToast("Image upload failed!", { type: "danger" });
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      if (error.response) {
        showToast("Error: " + error.response.data.message, { type: "danger" });
      } else {
        showToast("An unexpected error occurred.", { type: "danger" });
      }
    }
  };

  return (
    <>
      <Notification />
      <Form.Group className="mb-3">
        <Form.Label>Select an Image</Form.Label>
        <div className="d-flex align-items-center gap-3">
          <Form.Control
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            ref={fileInputRef} // Attach the ref to the file input
            style={{ display: "none" }} // Hide the default file input
          />
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => fileInputRef.current?.click()} // Trigger file input click
          >
            Choose File
          </Button>
          <span className="text-muted">
            {imageFile ? imageFile.name : "No file chosen"}
          </span>
        </div>
      </Form.Group>

      {imagePreview && (
        <div className="text-center mt-4">
          <img
            src={imagePreview}
            alt="Preview"
            className="img-fluid rounded shadow-sm"
            style={{ maxHeight: "300px", objectFit: "cover" }}
          />
          <div className="mt-3 d-flex justify-content-center gap-3">
            <Button
              variant="outline-success"
              className="upload_button"
              size="sm"
              onClick={uploadImage}
              disabled={uploaded} // Disable if already uploaded
            >
              <FaUpload className="me-2" />
              {uploaded ? "Uploaded" : "Upload"}
            </Button>

            <Button
              variant="danger"
              size="sm"
              onClick={removeImage}
              disabled={uploaded} // Disable if already uploaded
            >
              <FaRegTrashAlt className="me-2" />
              Remove
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadImage;